<template>
  <v-container fluid>
    <v-row no-gutters>
      <Header
        :title="'Pracoviská'"
        :subtitle="'V marketingu platí zásada, že treba prezentovať výhody a nie vlastnosti produktov. Pomôžte zákazníkovi vyriešiť jeho problém, splniť jeho túžbu.'"
      />
    </v-row>
    <v-row>
      <v-col md="2" sm="6" xs="12" v-for="item in workplaces" :key="item.id">
        <v-hover v-slot:default="{ hover }" open-delay="10">
          <WorkplaceHeaderButtons
            :title="item.description"
            :elevation="hover ? 16 : 1"
            :iconColor="'success'"
            :workplace="item"
          />
        </v-hover>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Header from "@/components/Header";
import WorkplaceHeaderButtons from "./components/WorkplaceHeaderButtons";

export default {
  name: "WorkplaceOverview",
  components: {
    Header,
    WorkplaceHeaderButtons
  },
  data: () => ({
    workplaces: []
  }),

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      this.openGlobalLoader("Načítava sa ...");
      this.services
        .workplaceService()
        .getWorkplaces()
        .then(response => {
          this.workplaces = response.data;
        })
        .finally(() => {
          this.closeGlobalLoader();
        });
    }
  }
};
</script>
